import cn from 'classnames';
import styles from './Logo.module.scss';
import darkIcon from '../../resources/icons/dark.svg';
import whiteIcon from '../../resources/icons/white.svg';

export const Logo = ({className, color = 'white'}) => {
    return (
        <a href={`${process.env.PUBLIC_URL.replace('/action','')}`} className={cn(styles.link, className)}>
            <img src={color === 'dark' ? darkIcon : whiteIcon} className={styles.logo} alt="2x2"/>
        </a>
    );
};